interface CategoryCardProps {
  name: string;
  description: string;
  url: string;
  icon: string;
  image?: string;
}

export default function CategoryCard({ name, description, url, icon, image }: CategoryCardProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener nofollow"
      className="block bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300 group cursor-pointer border border-background-200/70"
    >
      {image && (
        <div className="w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full flex-shrink-0">
            <i className={`${icon} text-sm text-accent-600`}></i>
          </div>
          <h3 className="text-base font-label font-semibold text-foreground-950 whitespace-nowrap">
            {name}
          </h3>
        </div>
        <p className="text-xs text-foreground-600 leading-relaxed">
          {description}
        </p>
        <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 font-label font-medium opacity-0 group-hover:opacity-100 transition-opacity">
          Shop Now
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-[10px]"></i>
          </span>
        </div>
      </div>
    </a>
  );
}